(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPricingOptionPackSelector", [
    "ToastManager",
    "HttpPendingRequestsService",
    function (ToastManager, HttpPendingRequestsService) {
      function getAllOptionsBase($element) {
        return $element.find(".ty-pricing-option-pack-selector__checkbox");
      }

      var controller = [
          "$scope",
          "$element",
          "PricingPageAnalyticsService",
          "$rootScope",
          "$filter",
          "Range",
          function ($scope, $element, PricingPageAnalyticsService, $rootScope, $filter, Range) {
            var ctl = this;
            var firstPass = true;

            function init() {
              $scope.savedOption = null;
            }

            $scope.$on("variant-changed", function (event, pricingPageVariantChangedData) {
              if (pricingPageVariantChangedData.grade && !pricingPageVariantChangedData.grade.containsOptionPacks) {
                return;
              }

              $scope.eventData = pricingPageVariantChangedData;
              $scope.variantIds = pricingPageVariantChangedData.variantIds;
              disableAndUncheckImpossibleSelections();
              updateOptionCheckboxes($scope.variantIds);
              ctl.updateVariantIds(pricingPageVariantChangedData.source);
            });

            ctl.updateVariantIds = function (source) {
              var variantIds = angular.copy($scope.variantIds);
              var $allOptions = getAllOptions();

              if (firstPass) {
                firstPass = false;

                $allOptions.each(function () {
                  var $option = angular.element(this);

                  if ($option.data("variant-ids").indexOf(ctl.initialVariantId) > -1) {
                    $option.prop("checked", true);
                  }
                });
              }

              var $selectedOption = getSelectedOption();

              if ($selectedOption.length === 1) {
                var optionPackVariantIds = $selectedOption.data("variant-ids");
                variantIds = $filter("arrayIntersect")(variantIds, optionPackVariantIds);
              } else {
                var allOptionPacksVariantIds = [];
                $allOptions.each(function () {
                  var $option = angular.element(this);
                  allOptionPacksVariantIds = allOptionPacksVariantIds.concat($option.data("variant-ids"));
                });
                variantIds = $filter("arraySubtract")(variantIds, allOptionPacksVariantIds);
              }


              var availableOptions = getAvailableOptions();
              if (!availableOptions || !availableOptions.length) {
                PricingPageAnalyticsService.setExtras("");
              } else {
                PricingPageAnalyticsService.setExtras($scope.savedOption || "");
              }


              if (source === "option-pack" && $scope.savedOption) {
                // This strips out the HTML tags so the extras label stays clean
                var cleanSavedOption = $scope.savedOption.replace(/<[^>]*>/g, "");
                PricingPageAnalyticsService.triggerAnalytics("gaClick", {
                  eventCategory: "pricing",
                  eventAction: "button - " + $element.data("section-label").toLowerCase(),
                  eventLabel: cleanSavedOption,
                });
              }

              sendChangedEvent(variantIds, source);
            };

            function disableAndUncheckImpossibleSelections() {
              var $availableOptions = getAllOptions().filter(function (index, option) {
                var variantIdsForOption = angular.fromJson(angular.element(option).data("variant-ids"));
                return $filter("arrayIntersect")(variantIdsForOption, $scope.variantIds).length > 0;
              });

              var $unavailableOptions = getAllOptions().not($availableOptions);

              var aboutToUncheckDisabledOption = $unavailableOptions.filter(":checked").length;

              ToastManager.removeToastsByGroup("option-pack-unavailable");
              if (aboutToUncheckDisabledOption) {
                ToastManager.triggerBriefToast(
                  "Your selected additional extras are unavailable on current configuration.",
                  "option-pack-unavailable"
                );
              }

              getAllOptions().prop("disabled", false);
              $unavailableOptions.prop("disabled", true).prop("checked", false);

              updateDisabledReasons();
            }

            function updateOptionDetails($optionCheckbox, enabled, disabledReason) {
              var $optionCheckboxContainer = $optionCheckbox.parent(".ty-pricing-option-pack-selector-item");
              var $disabledReason = $optionCheckboxContainer.find(
                ".ty-pricing-option-pack-selector-item__disabled-reason"
              );
              var $learnMoreLink = $optionCheckboxContainer.find(".ty-pricing-option-pack-selector-item__link");

              if (enabled) {
                $learnMoreLink.css("display", "");
                $disabledReason.css("display", "none");
                return;
              }

              var showDisabledReason = !enabled && !!disabledReason;
              $learnMoreLink.css("display", "none");
              $disabledReason.css("display", showDisabledReason ? "" : "none").text(disabledReason);
            }

            function updateDisabledReasons() {
              var variantIdsInGrade = Range.getVariantsByGradeIdFromCache($scope.eventData.grade.id).map(function (
                variant
              ) {
                return variant.id;
              });

              var $options = getAllOptions();

              var $optionsDisabledDueToGrade = $options.filter(function (index, option) {
                return (
                  $filter("arrayIntersect")(variantIdsInGrade, angular.element(option).data("variant-ids")).length === 0
                );
              });

              var $optionsDisabledDueToVariant = $options.filter(":disabled").filter(function (index, option) {
                return (
                  $filter("arrayIntersect")(variantIdsInGrade, angular.element(option).data("variant-ids")).length > 0
                );
              });

              var $optionsEnabled = $options.not($optionsDisabledDueToGrade).not($optionsDisabledDueToVariant);

              $optionsDisabledDueToGrade.each(function () {
                updateOptionDetails(
                  angular.element(this),
                  false,
                  $element.data("grade-message") + " " + $scope.eventData.grade.name
                );
              });
              $optionsDisabledDueToVariant.each(function () {
                updateOptionDetails(angular.element(this), false, $element.data("variant-message"));
              });
              $optionsEnabled.each(function () {
                updateOptionDetails(angular.element(this), true);
              });
            }

            function updateOptionCheckboxes(validVariantIds) {
              var $availableOptions = getAvailableOptions();

              if (!$availableOptions.length) {
                return;
              }

              $availableOptions.prop("checked", false);

              var forcedSelection = false;

              $availableOptions.each(function (index, option) {
                var $option = angular.element(option);
                var optionVariantIds = $option.data("variantIds");

                var variantIds = $filter("arrayIntersect")(validVariantIds, optionVariantIds);

                if (variantIds.length > 0 && variantIds.length === validVariantIds.length) {
                  $option.prop("checked", true);
                }
              });

              if (!forcedSelection && $scope.savedOption) {
                var $savedOption = $availableOptions.filter('[data-option="' + $scope.savedOption + '"]');
                if (!$savedOption.prop("checked")) {
                  $savedOption.prop("checked", true);
                }
              }
            }

            function sendChangedEvent(variantIds, source) {
              if (source !== "grade") {
                HttpPendingRequestsService.cancelAll();
              }

              $rootScope.$broadcast("option-pack-changed", {
                grade: $scope.eventData.grade,
                variantIds: variantIds,
                source: source,
              });
            }

            function getSelectedOption() {
              return getAllOptions().filter(":checked");
            }

            function getAvailableOptions() {
              return getAllOptions().filter(":not(:disabled)");
            }

            function getAllOptions() {
              return getAllOptionsBase($element);
            }

            ctl.saveUserSelection = function () {
              var $selection = getSelectedOption();
              var option = $selection.length ? $selection.attr("data-option") : null;
              $scope.savedOption = option;
            };

            ctl.$onInit = init;
          },
        ],
        link = function ($scope, $element) {
          var tyPricingOptionPackSelectorController = $scope.tyPricingOptionPackSelectorController;

          function getAllOptions() {
            return getAllOptionsBase($element);
          }

          var $allOptions = getAllOptions();

          $allOptions.on("change", function (event) {
            var $changedOptionCheckbox = angular.element(event.target);
            $allOptions.not($changedOptionCheckbox).prop("checked", false);
            tyPricingOptionPackSelectorController.saveUserSelection();
            tyPricingOptionPackSelectorController.updateVariantIds("option-pack");
            ToastManager.removeToastsByGroup("option-pack-unavailable");
          });
        };

      return {
        bindToController: {
          initialVariantId: "<",
        },
        scope: true,
        restrict: "A",
        controller: controller,
        controllerAs: "tyPricingOptionPackSelectorController",
        link: link,
      };
    },
  ]);
})(window.angular);
